import { destroy, get, post, put } from '.';

export function GetCampaignDispositionGroups(options = {}) {
	return get<any>("/app/api/campaign_disposition_groups", options);
}

export function GetAvailableCampaignDispositionGroups(options = {}) {
	return get<any>("/app/api/campaign_disposition_groups/available", options);
}

export function CreateCampaignDispositionGroup(options = {}) {
	return post<any>("/app/api/campaign_disposition_groups", options);
}

export function DestroyCampaignDispositionGroup(id, options = {}) {
	return destroy<any>(`/app/api/campaign_disposition_groups/${id}`, options);
}

export function ReorderCampaignDispositionGroup(options = {}) {
	return put<any>("/app/api/campaign_disposition_groups/reorder", options);
}